import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "rounded-lg bg-gray-100 p-2 shadow-lg sm:p-3" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between" }
const _hoisted_4 = { class: "flex w-0 flex-1 items-center" }
const _hoisted_5 = { class: "flex rounded-lg bg-teal-500 p-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "ml-3 truncate font-medium text-grey" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "md:hidden" }, "Entire Villa available!"),
  /*#__PURE__*/_createElementVNode("span", { class: "hidden md:inline" }, "The Entire Villa is available!")
], -1)
const _hoisted_7 = { class: "order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto" }

import { CheckCircleIcon, CheckIcon } from "@heroicons/vue/outline";
import { InformationCircleIcon } from "@heroicons/vue/solid";

export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  props: ['label'],
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_unref(InformationCircleIcon), {
              class: "h-6 w-6 text-white",
              "aria-hidden": "true"
            })
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selected'))),
            class: "flex cursor-pointer items-center justify-center rounded-md border border-transparent bg-teal-100 px-4 py-2 text-sm font-medium text-teal-600 shadow-sm hover:bg-indigo-50"
          }, [
            (props.label == 'Selected')
              ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                  key: 0,
                  class: "h-6 w-6 text-green mr-2",
                  "aria-hidden": "true"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(props.label), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})